<template>
  <div class="good-group">
    <template v-if="templateType">
      <template v-if="list.length > 0">
        <!-- 瀑布流三列布局 -->
        <div v-if="templateType === 'tris'" class="triple-column-layout">
          <div
            v-for="(column, colIndex) in threeColumnData"
            :key="colIndex"
            class="column"
            :style="goodStyle"
          >
            <component
              :is="componentType"
              v-for="(item, index) in column"
              :key="`${item.ssu.ssuInfo.ssuId}-${colIndex}-${index}`"
              v-expose-track="{
                cms: {
                  mapId: 'cmsStrageGoodExpose',
                  data: {
                    spm: item.ssu.ssuInfo.tickerInfo.goods.spm,
                    ...item.ssu.ssuInfo.tickerInfo.data,
                    ...item.ssu.ssuInfo.tickerInfo.goods.spmJson,
                    ...{ sku_pos: index }
                  }
                }
              }"
              :ssu="item.ssu"
              :sku-index="index"
              :good-width="goodWidth"
              :type="templateType"
              :style="{ marginBottom: '8px', ...goodStyle }"
            />
          </div>
        </div>

        <!-- 瀑布流双列布局 -->
        <div v-else-if="templateType === 'double'" class="double-column-layout">
          <div
            v-for="(column, colIndex) in twoColumnData"
            :key="colIndex"
            class="column"
            :style="goodStyle"
          >
            <component
              :is="componentType"
              v-for="(item, index) in column"
              :key="`${item.ssu.ssuInfo.ssuId}-${colIndex}-${index}`"
              v-expose-track="{
                cms: {
                  mapId: 'cmsStrageGoodExpose',
                  data: {
                    spm: item.ssu.ssuInfo.tickerInfo.goods.spm,
                    ...item.ssu.ssuInfo.tickerInfo.data,
                    ...item.ssu.ssuInfo.tickerInfo.goods.spmJson,
                    ...{ sku_pos: index }
                  }
                }
              }"
              :ssu="item.ssu"
              :sku-index="index"
              :good-width="goodWidth"
              :type="templateType"
              :style="{ marginBottom: '8px', ...goodStyle }"
            />
          </div>
        </div>

        <!-- 单列布局 -->
        <div v-else-if="templateType === 'sole'" class="single-layout">
          <component
            :is="componentType"
            v-for="(item, index) in list"
            :key="`${item.ssu.ssuInfo.ssuId}-${index}`"
            v-expose-track="{
              cms: {
                mapId: 'cmsStrageGoodExpose',
                data: {
                  spm: item.ssu.ssuInfo.tickerInfo.goods.spm,
                  ...item.ssu.ssuInfo.tickerInfo.data,
                  ...item.ssu.ssuInfo.tickerInfo.goods.spmJson,
                  ...{ sku_pos: index }
                }
              }
            }"
            :ssu="item.ssu"
            :sku-index="index"
            :good-width="goodWidth"
            :type="templateType"
            :style="{ marginBottom: '8px', ...goodStyle }"
          />
        </div>
      </template>
      <template v-else>
        <!-- 暂无商品 -->
        <empty
          :desc="'暂无商品'"
          :type="1"
          :img="'Empty'"
          class="empty-box"
        ></empty>
      </template>
    </template>
  </div>
</template>
<script>
import Empty from '@/common/layout/empty/index'
import FeedGood from './components/FeedGood'
import { calcGoodsList } from '@/utils/goods/util'

import newSoleGood from '../goods/template/components/new-sole-good.vue'
import newDoubleGood from '../goods/template/components/new-double-good.vue'
import newTrisScrollGood from '../goods/template/components/new-tris-scroll-good.vue'

const newEnumComponentType = {
  sole: 'new-sole-good',
  double: 'new-double-good',
  tris: 'new-tris-scroll-good'
}

export default {
  components: {
    FeedGood,
    Empty,
    newSoleGood,
    newDoubleGood,
    newTrisScrollGood
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    templateType: {
      type: String,
      default: ''
    },
    goodWidth: {
      type: [String, Number],
      default: ''
    },
    goodStyle: {
      type: Object,
      default: () => ({})
    },
    factor: {
      type: [String, Number],
      default: 1
    }
  },
  data() {
    return {}
  },
  computed: {
    componentType() {
      return newEnumComponentType[this.templateType]
    },
    threeColumnData() {
      if (this.templateType !== 'tris') return [[], [], []]

      const columns = [[], [], []]
      this.list.forEach((item, index) => {
        columns[index % 3].push(item)
      })

      return columns
    },

    // 双列数据（用于双列瀑布流布局）
    twoColumnData() {
      if (this.templateType !== 'double') return [[], []]

      const columns = [[], []]
      this.list.forEach((item, index) => {
        columns[index % 2].push(item)
      })

      return columns
    }
  },
  methods: {
    // 处理列表数据
    handleListData(list) {
      if (Array.isArray(list) && list.length) {
        this.goods = list
          .map(item => {
            /**
             * object_type 商品类型
             * 2：广告位
             * 3：小美帮你选
             */
            if (item.object_type === 2 || item.object_type === 3) {
              return item
            } else {
              const calcedGoodsList = calcGoodsList([item]) || []
              return calcedGoodsList[0]
            }
          })
          .filter(item => item)
      } else {
        this.goods = []
      }
    },
    onTick(evt, data) {
      // eslint-disable-next-line vue/custom-event-name-casing
      this.$emit('onTick', evt, data)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixin.scss';
.good-group {
  width: 100%;
}
.group {
  width: 100%;
  @include flex-row-between;

  &.flex-start {
    @include flex(row, flex-start, flex-start, nowrap);
  }
}
.triple-column-layout {
  display: flex;
  justify-content: space-between;

  .column {
    // width: calc(33.33% - 6px);
  }
}
.double-column-layout {
  display: flex;
  justify-content: space-between;

  .left-column,
  .right-column {
    // width: calc(50% - 4px);
  }
}

.empty-box {
  position: relative;
  height: 100%;
  top: 2.4rem; /* 120/50 */
}
</style>
